import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import { LangProvider } from './i18n/LangContext';
import HomePage from './pages/HomePage';
import ProjectsPage from './pages/ProjectsPage';
import EmergencyPage from './pages/EmergencyPage';
import GeneralContractorMiami from './pages/GeneralContractorMiami';
import RemodelingMiami from './pages/RemodelingMiami';
import ProjectManagementMiami from './pages/ProjectManagementMiami';
import KitchenRemodelingMiami from './pages/KitchenRemodelingMiami';
import BathroomRemodelingMiami from './pages/BathroomRemodelingMiami';
import OutdoorLivingMiami from './pages/OutdoorLivingMiami';
import MultiTradeMiami from './pages/MultiTradeMiami';
import LandscapeDesignMiami from './pages/LandscapeDesignMiami';
import ConstructionTechnology from './pages/ConstructionTechnology';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import '@fontsource/outfit/800.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import './App.css';

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      let count = 0;
      const id = setInterval(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: count === 0 ? 'auto' : 'auto', block: 'start' });
        if (++count >= 12) clearInterval(id);
      }, 250);
      return () => clearInterval(id);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <LangProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/emergency-services" element={<EmergencyPage />} />
            <Route path="/general-contractor-miami" element={<GeneralContractorMiami />} />
            <Route path="/remodeling-miami" element={<RemodelingMiami />} />
            <Route path="/kitchen-remodeling-miami" element={<KitchenRemodelingMiami />} />
            <Route path="/bathroom-remodeling-miami" element={<BathroomRemodelingMiami />} />
            <Route path="/outdoor-living-miami" element={<OutdoorLivingMiami />} />
            <Route path="/multi-trade-miami" element={<MultiTradeMiami />} />
            <Route path="/landscape-design-miami" element={<LandscapeDesignMiami />} />
            <Route path="/construction-technology-automation" element={<ConstructionTechnology />} />
            <Route path="/project-management-miami" element={<ProjectManagementMiami />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </LangProvider>
    </HelmetProvider>
  );
}

export default App;
